enum type {
  SET_LIST_DOCUMENTS = 'SET_LIST_DOCUMENTS',
  SET_LOADING_DOCUMENTS = 'SET_LOADING_DOCUMENTS',
  SET_LIST_DOCUMENTS_BKP = 'SET_LIST_DOCUMENTS_BKP',
  SET_LIST_DOCUMENTS_MISSING = 'SET_LIST_DOCUMENTS_MISSING',
  SET_SELECTED_DOCUMENTS_TYPE = 'SET_SELECTED_DOCUMENTS_TYPE',
  SET_TOTAL_DOCUMENTS = 'SET_TOTAL_DOCUMENTS',
}

export default type;